module.exports = __webpack_public_path__ + "static/media/Patronato-Muyucocha.b3ed8b87.JPG";